export enum UserExistsStatus {
  Exists,
  DoesNotExist,
  ErrorRateLimit,
  ErrorGeneral,
}

export type UserExistsReturnValue = {
  exists: boolean;
  status: UserExistsStatus;
};
